import { STATIC_STRINGS } from "./Constants";

export const isNull = (value: any): boolean => {
  return value === null;
};

export const isUndefined = (value: any): boolean => {
  return value === undefined;
};

export const isEmptyObject = (value: any): boolean => {
  return (
    isUndefined(value) ||
    isNull(value) ||
    (typeof value === "object" && Object.keys(value).length === 0)
  );
};

export const isEmpty = (value) => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === "object" && Object.keys(value).length === 0) ||
    (typeof value === "string" && value.trim().length === 0) ||
    (Array.isArray(value) && value.length === 0)
  );
};

export const formatDateTime = (isoString: string) => {
  const date = new Date(isoString);

  // Extract date parts
  const day = date.getDate();
  const year = date.getFullYear();
  const monthNames = STATIC_STRINGS.MONTHS;
  const month = monthNames[date.getMonth()];

  // Extract time parts
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12; // Convert 24-hour format to 12-hour format

  return `${day}th ${month} ${hours}:${minutes} ${ampm}`;
};

export const getStartTime = () => {
  return new Date().toISOString().slice(0, 16);
};

export const calculateEndTime = (startTime: string, durationInHours = 1) => {
  const startDate = new Date(startTime);
  const timezoneOffset = new Date().getTimezoneOffset() * 60000;
  const endTime = new Date(
    startDate.getTime() + durationInHours * 60 * 60 * 1000 - timezoneOffset
  );
  return endTime.toISOString().slice(0, 16);
};

export const formatPercentage = (value, decimalPlaces) => {
  if (typeof value !== "number" || typeof decimalPlaces !== "number") {
    throw new Error("Both arguments must be numbers");
  }

  return `${(value * 100).toFixed(decimalPlaces)}`;
};
